import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { DIALOG_DATA, getRandomInteger } from '../../../../global.variable';
import { ToasterService } from '../../services/toaster.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';

@Component({
  selector: 'gtapp-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  standalone: false,
})
export class ConfirmDialogComponent implements OnInit {
  @Output('emitData') emitData = new EventEmitter();
  title: any;
  message: any;
  messageStyle: any;

  confirmation: boolean = false;

  confirmNumber: any;
  randomNumber: number = 0;

  customTemplate!: TemplateRef<any>;

  btn1Detail: any = {};
  btn2Detail: any = {};

  constructor(
    protected dialogueRef: DialogRef,
    @Inject(DIALOG_DATA) public dialogData: any,
    private toasterService: ToasterService,
  ) {}
  ngOnInit(): void {
    this.randomNumber = getRandomInteger(1000, 9999);

    this.title = this.dialogData?.title;
    this.message = this.dialogData?.message;
    this.messageStyle = this.dialogData?.messageStyle;
    this.confirmation = this.dialogData?.confirmation;
    this.customTemplate = this.dialogData?.customTemplate;
    this.btn1Detail = this.dialogData?.btn1Detail;
    this.btn2Detail = this.dialogData?.btn2Detail;
  }
  onConfirm(): void {
    if (this.confirmation) {
      if (this.randomNumber == this.confirmNumber) {
        this.dialogueRef.close(true);
      } else {
        this.toasterService.setMessage({
          errorMessage: `Numbers don't match`,
          successMessage: '',
        });
      }
    } else {
      this.dialogueRef.close(true);
    }
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogueRef.close(false);
  }
}
